export const QUERY_AGAIN_TIMEOUT = 100;
